cv.validateEmails = function(emailList){
  var emails = emailList.replace(/\s/g,'').split(",");

  var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if(emails.length > 15){
    return 'Exceeded maximum number of e-mails.';
  }
  for (var i = 0; i < emails.length; i++) {
    if( emails[i] == "" || ! regex.test(emails[i])){
      return 'One or more invalid e-mails entered.';
    }
  }

  return '';
};